document.addEventListener("DOMContentLoaded", function () {
  const storeLink = document.getElementById("store_link");
  const announcementBar = document.getElementById("announcement-bar");

  storeLink.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent default action of the link

    // Copy the page URL to the clipboard
    navigator.clipboard
      .writeText(window.location.href)
      .then(function () {
        // Show the announcement bar after successful copy
        announcementBar.style.display = "block";

        // Hide the announcement bar after 3 seconds
        setTimeout(function () {
          announcementBar.style.display = "none";
        }, 3000);
      })
      .catch(function () {
        console.error("Failed to copy the link to clipboard.");
      });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("toggle-description");
  const description = document.querySelector(".fulldescritpion");
  const moreText = toggleButton.querySelector(".more");
  const lessText = toggleButton.querySelector(".less");

  toggleButton.addEventListener("click", function () {
    description.classList.toggle("expanded");
    const isExpanded = description.classList.contains("expanded");

    moreText.style.display = isExpanded ? "none" : "inline";
    lessText.style.display = isExpanded ? "inline" : "none";
  });
});
